import { BorderRadius, Color, getShadow, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const AdditionalModalInformationWrapper = styled.div`
  padding: ${Spacing.S12};
  border: 1px solid ${Color.Purple200};
  border-radius: ${BorderRadius.R12};
  background-color: ${Color.Purple50};
  ${getShadow('raisedLight')};
`

export const AdditionalModalInformationHeader = styled.div`
  display: flex;
  align-items: center;
`
